// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-color[data-v-06805633]{\n  color: #D4AF37;\n}\n\n", ""]);
// Exports
module.exports = exports;
